"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DfaState = void 0;
var CharMatcher_1 = require("./CharMatcher");
/** @constructor */
var DfaState = /** @class */ (function () {
    function DfaState() {
        this.nfaStates = [];
        this.next = {};
        this.accepts = [];
        this.id = CharMatcher_1.getNextStateId(); //NextStateId++;
    }
    return DfaState;
}());
exports.DfaState = DfaState;
//# sourceMappingURL=DfaState.js.map